import type { Attributes as OtelAttributes, AttributeValue as OtelAttributeValue } from '@opentelemetry/api'

/**
 * Extends OTEL attribute values to permit null/undefined which will
 * get filtered out before sending to OTEL.
 */
export type SpanAttributeValue = OtelAttributeValue | null | undefined

/** Typeguard to check if value is a valid OTEL attribute value */

const isValidOtelValue = (value: SpanAttributeValue) => {
  return value != null
}
/**
 * OTEL does not permit null / undefined.
 * This function filters out nullish values and acts as a typeguard to produce a valid OTEL attributes object
 */
export const toOtelAttributes = (input: Record<string, SpanAttributeValue>): OtelAttributes => {
  const result: OtelAttributes = {}

  for (const key of Object.keys(input)) {
    const value = input[key]
    if (isValidOtelValue(value)) {
      result[key] = value
    }
  }

  return result
}
